(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._errorWrapper_171rr_1{word-break:break-word}._copyIcon_171rr_5{cursor:pointer;color:var(--dixa-typography-color-secondary)}._settingsWrapper_eleyu_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-300)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { gql as Z, useQuery as Qt, useLazyQuery as Zt, useMutation as Oe, isApolloError as Xt } from "@apollo/client";
import { __extends as er } from "tslib";
import ft, { useState as R, useEffect as F, createContext as gt, useContext as pt, useCallback as xe } from "react";
import { FormField as ge, FieldWrapper as Q, Badge as Le, Icon as $e, FlexBox as M, Text as oe, List as nt, Banner as tr, Button as ie, Modal as rr, ModalHead as nr, ModalBody as or, ModalFoot as ir, Tooltip as ht, Spinner as mt, FieldSwitch as ar, InputSelectionList as sr, SelectionList as cr } from "@dixa/lib-shared-habla";
import { Link as lr } from "react-router-dom";
import { colors as K } from "@dixa/lib-shared-tokens";
import vt from "moment";
import { useInterval as ur } from "react-use";
import { HookFormText as dr } from "lib-shared-hook-form";
const dn = Z`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, fr = Z`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, gr = Z`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, pr = Z`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`;
var Fe = "Invariant Violation", ot = Object.setPrototypeOf, hr = ot === void 0 ? function(t, r) {
  return t.__proto__ = r, t;
} : ot, mr = (
  /** @class */
  (function(t) {
    er(r, t);
    function r(o) {
      o === void 0 && (o = Fe);
      var i = t.call(this, typeof o == "number" ? Fe + ": " + o + " (see https://github.com/apollographql/invariant-packages)" : o) || this;
      return i.framesToPop = 1, i.name = Fe, hr(i, r.prototype), i;
    }
    return r;
  })(Error)
);
function q(t, r) {
  if (!t)
    throw new mr(r);
}
var yt = ["debug", "log", "warn", "error", "silent"], vr = yt.indexOf("log");
function we(t) {
  return function() {
    if (yt.indexOf(t) >= vr) {
      var r = console[t] || console.log;
      return r.apply(console, arguments);
    }
  };
}
(function(t) {
  t.debug = we("debug"), t.log = we("log"), t.warn = we("warn"), t.error = we("error");
})(q || (q = {}));
var Et = "3.14.0";
function ne(t) {
  try {
    return t();
  } catch {
  }
}
const it = ne(function() {
  return globalThis;
}) || ne(function() {
  return window;
}) || ne(function() {
  return self;
}) || ne(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
ne(function() {
  return ne.constructor("return this")();
});
var at = /* @__PURE__ */ new Map();
function yr(t) {
  var r = at.get(t) || 1;
  return at.set(t, r + 1), "".concat(t, ":").concat(r, ":").concat(Math.random().toString(36).slice(2));
}
function Er(t, r) {
  var o = yr("stringifyForDisplay");
  return JSON.stringify(t, function(i, c) {
    return c === void 0 ? o : c;
  }, r).split(JSON.stringify(o)).join("<undefined>");
}
function Te(t) {
  return function(r) {
    for (var o = [], i = 1; i < arguments.length; i++)
      o[i - 1] = arguments[i];
    if (typeof r == "number") {
      var c = r;
      r = Ct(c), r || (r = xt(c, o), o = []);
    }
    t.apply(void 0, [r].concat(o));
  };
}
Object.assign(function(r, o) {
  for (var i = [], c = 2; c < arguments.length; c++)
    i[c - 2] = arguments[c];
  r || q(r, Ct(o, i) || xt(o, i));
}, {
  debug: Te(q.debug),
  log: Te(q.log),
  warn: Te(q.warn),
  error: Te(q.error)
});
var st = Symbol.for("ApolloErrorMessageHandler_" + Et);
function bt(t) {
  if (typeof t == "string")
    return t;
  try {
    return Er(t, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function Ct(t, r) {
  if (r === void 0 && (r = []), !!t)
    return it[st] && it[st](t, r.map(bt));
}
function xt(t, r) {
  if (r === void 0 && (r = []), !!t)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: Et,
      message: t,
      args: r.map(bt)
    })));
}
function Re(t) {
  return t.definitions.filter(function(r) {
    return r.kind === "OperationDefinition" && !!r.name;
  }).map(function(r) {
    return r.name.value;
  })[0] || null;
}
const fn = (t, r) => function(o, i) {
  return Qt(o, {
    ...i,
    context: {
      operationName: Re(o),
      ...i?.context,
      widgetId: t,
      widgetType: r
    }
  });
}, gn = (t, r) => function(o, i) {
  return Zt(o, {
    ...i,
    context: {
      operationName: Re(o),
      ...i?.context,
      widgetId: t,
      widgetType: r
    }
  });
}, pn = (t, r, o) => function(i, c) {
  return o.query({
    query: i,
    variables: c,
    context: {
      operationName: Re(i),
      widgetId: t,
      widgetType: r
    }
  });
}, hn = (t, r) => function(o, i) {
  return Oe(o, {
    ...i,
    context: {
      operationName: Re(o),
      ...i?.context,
      widgetId: t,
      widgetType: r
    }
  });
};
var _e = { exports: {} }, de = {};
var ct;
function br() {
  if (ct) return de;
  ct = 1;
  var t = ft, r = Symbol.for("react.element"), o = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, c = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, d = { key: !0, ref: !0, __self: !0, __source: !0 };
  function g(C, p, x) {
    var u, v = {}, w = null, T = null;
    x !== void 0 && (w = "" + x), p.key !== void 0 && (w = "" + p.key), p.ref !== void 0 && (T = p.ref);
    for (u in p) i.call(p, u) && !d.hasOwnProperty(u) && (v[u] = p[u]);
    if (C && C.defaultProps) for (u in p = C.defaultProps, p) v[u] === void 0 && (v[u] = p[u]);
    return { $$typeof: r, type: C, key: w, ref: T, props: v, _owner: c.current };
  }
  return de.Fragment = o, de.jsx = g, de.jsxs = g, de;
}
var fe = {};
var lt;
function Cr() {
  return lt || (lt = 1, process.env.NODE_ENV !== "production" && (function() {
    var t = ft, r = Symbol.for("react.element"), o = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), c = Symbol.for("react.strict_mode"), d = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), C = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), x = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), S = Symbol.iterator, D = "@@iterator";
    function N(e) {
      if (e === null || typeof e != "object")
        return null;
      var n = S && e[S] || e[D];
      return typeof n == "function" ? n : null;
    }
    var f = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(e) {
      {
        for (var n = arguments.length, s = new Array(n > 1 ? n - 1 : 0), l = 1; l < n; l++)
          s[l - 1] = arguments[l];
        I("error", e, s);
      }
    }
    function I(e, n, s) {
      {
        var l = f.ReactDebugCurrentFrame, E = l.getStackAddendum();
        E !== "" && (n += "%s", s = s.concat([E]));
        var b = s.map(function(m) {
          return String(m);
        });
        b.unshift("Warning: " + n), Function.prototype.apply.call(console[e], console, b);
      }
    }
    var V = !1, J = !1, B = !1, Se = !1, ae = !1, pe;
    pe = Symbol.for("react.module.reference");
    function Ae(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === i || e === d || ae || e === c || e === x || e === u || Se || e === T || V || J || B || typeof e == "object" && e !== null && (e.$$typeof === w || e.$$typeof === v || e.$$typeof === g || e.$$typeof === C || e.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === pe || e.getModuleId !== void 0));
    }
    function De(e, n, s) {
      var l = e.displayName;
      if (l)
        return l;
      var E = n.displayName || n.name || "";
      return E !== "" ? s + "(" + E + ")" : s;
    }
    function he(e) {
      return e.displayName || "Context";
    }
    function W(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case i:
          return "Fragment";
        case o:
          return "Portal";
        case d:
          return "Profiler";
        case c:
          return "StrictMode";
        case x:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case C:
            var n = e;
            return he(n) + ".Consumer";
          case g:
            var s = e;
            return he(s._context) + ".Provider";
          case p:
            return De(e, e.render, "ForwardRef");
          case v:
            var l = e.displayName || null;
            return l !== null ? l : W(e.type) || "Memo";
          case w: {
            var E = e, b = E._payload, m = E._init;
            try {
              return W(m(b));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, L = 0, me, ve, se, ce, X, ye, le;
    function A() {
    }
    A.__reactDisabledLog = !0;
    function Y() {
      {
        if (L === 0) {
          me = console.log, ve = console.info, se = console.warn, ce = console.error, X = console.group, ye = console.groupCollapsed, le = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: A,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        L++;
      }
    }
    function $() {
      {
        if (L--, L === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, e, {
              value: me
            }),
            info: U({}, e, {
              value: ve
            }),
            warn: U({}, e, {
              value: se
            }),
            error: U({}, e, {
              value: ce
            }),
            group: U({}, e, {
              value: X
            }),
            groupCollapsed: U({}, e, {
              value: ye
            }),
            groupEnd: U({}, e, {
              value: le
            })
          });
        }
        L < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var G = f.ReactCurrentDispatcher, H;
    function ee(e, n, s) {
      {
        if (H === void 0)
          try {
            throw Error();
          } catch (E) {
            var l = E.stack.trim().match(/\n( *(at )?)/);
            H = l && l[1] || "";
          }
        return `
` + H + e;
      }
    }
    var Ne = !1, Ee;
    {
      var Ot = typeof WeakMap == "function" ? WeakMap : Map;
      Ee = new Ot();
    }
    function Ue(e, n) {
      if (!e || Ne)
        return "";
      {
        var s = Ee.get(e);
        if (s !== void 0)
          return s;
      }
      var l;
      Ne = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var b;
      b = G.current, G.current = null, Y();
      try {
        if (n) {
          var m = function() {
            throw Error();
          };
          if (Object.defineProperty(m.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(m, []);
            } catch (j) {
              l = j;
            }
            Reflect.construct(e, [], m);
          } else {
            try {
              m.call();
            } catch (j) {
              l = j;
            }
            e.call(m.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (j) {
            l = j;
          }
          e();
        }
      } catch (j) {
        if (j && l && typeof j.stack == "string") {
          for (var h = j.stack.split(`
`), P = l.stack.split(`
`), _ = h.length - 1, O = P.length - 1; _ >= 1 && O >= 0 && h[_] !== P[O]; )
            O--;
          for (; _ >= 1 && O >= 0; _--, O--)
            if (h[_] !== P[O]) {
              if (_ !== 1 || O !== 1)
                do
                  if (_--, O--, O < 0 || h[_] !== P[O]) {
                    var k = `
` + h[_].replace(" at new ", " at ");
                    return e.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", e.displayName)), typeof e == "function" && Ee.set(e, k), k;
                  }
                while (_ >= 1 && O >= 0);
              break;
            }
        }
      } finally {
        Ne = !1, G.current = b, $(), Error.prepareStackTrace = E;
      }
      var re = e ? e.displayName || e.name : "", z = re ? ee(re) : "";
      return typeof e == "function" && Ee.set(e, z), z;
    }
    function Rt(e, n, s) {
      return Ue(e, !1);
    }
    function St(e) {
      var n = e.prototype;
      return !!(n && n.isReactComponent);
    }
    function be(e, n, s) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return Ue(e, St(e));
      if (typeof e == "string")
        return ee(e);
      switch (e) {
        case x:
          return ee("Suspense");
        case u:
          return ee("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case p:
            return Rt(e.render);
          case v:
            return be(e.type, n, s);
          case w: {
            var l = e, E = l._payload, b = l._init;
            try {
              return be(b(E), n, s);
            } catch {
            }
          }
        }
      return "";
    }
    var ue = Object.prototype.hasOwnProperty, Ge = {}, Ve = f.ReactDebugCurrentFrame;
    function Ce(e) {
      if (e) {
        var n = e._owner, s = be(e.type, e._source, n ? n.type : null);
        Ve.setExtraStackFrame(s);
      } else
        Ve.setExtraStackFrame(null);
    }
    function At(e, n, s, l, E) {
      {
        var b = Function.call.bind(ue);
        for (var m in e)
          if (b(e, m)) {
            var h = void 0;
            try {
              if (typeof e[m] != "function") {
                var P = Error((l || "React class") + ": " + s + " type `" + m + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[m] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw P.name = "Invariant Violation", P;
              }
              h = e[m](n, m, l, s, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (_) {
              h = _;
            }
            h && !(h instanceof Error) && (Ce(E), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", l || "React class", s, m, typeof h), Ce(null)), h instanceof Error && !(h.message in Ge) && (Ge[h.message] = !0, Ce(E), y("Failed %s type: %s", s, h.message), Ce(null));
          }
      }
    }
    var Dt = Array.isArray;
    function Ie(e) {
      return Dt(e);
    }
    function Nt(e) {
      {
        var n = typeof Symbol == "function" && Symbol.toStringTag, s = n && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return s;
      }
    }
    function It(e) {
      try {
        return Ye(e), !1;
      } catch {
        return !0;
      }
    }
    function Ye(e) {
      return "" + e;
    }
    function He(e) {
      if (It(e))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Nt(e)), Ye(e);
    }
    var Ke = f.ReactCurrentOwner, Pt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Je, ze;
    function jt(e) {
      if (ue.call(e, "ref")) {
        var n = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function kt(e) {
      if (ue.call(e, "key")) {
        var n = Object.getOwnPropertyDescriptor(e, "key").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Mt(e, n) {
      typeof e.ref == "string" && Ke.current;
    }
    function Ft(e, n) {
      {
        var s = function() {
          Je || (Je = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        s.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: s,
          configurable: !0
        });
      }
    }
    function Wt(e, n) {
      {
        var s = function() {
          ze || (ze = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        s.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: s,
          configurable: !0
        });
      }
    }
    var Lt = function(e, n, s, l, E, b, m) {
      var h = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: e,
        key: n,
        ref: s,
        props: m,
        // Record the component responsible for creating this element.
        _owner: b
      };
      return h._store = {}, Object.defineProperty(h._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(h, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: l
      }), Object.defineProperty(h, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(h.props), Object.freeze(h)), h;
    };
    function $t(e, n, s, l, E) {
      {
        var b, m = {}, h = null, P = null;
        s !== void 0 && (He(s), h = "" + s), kt(n) && (He(n.key), h = "" + n.key), jt(n) && (P = n.ref, Mt(n, E));
        for (b in n)
          ue.call(n, b) && !Pt.hasOwnProperty(b) && (m[b] = n[b]);
        if (e && e.defaultProps) {
          var _ = e.defaultProps;
          for (b in _)
            m[b] === void 0 && (m[b] = _[b]);
        }
        if (h || P) {
          var O = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          h && Ft(m, O), P && Wt(m, O);
        }
        return Lt(e, h, P, E, l, Ke.current, m);
      }
    }
    var Pe = f.ReactCurrentOwner, qe = f.ReactDebugCurrentFrame;
    function te(e) {
      if (e) {
        var n = e._owner, s = be(e.type, e._source, n ? n.type : null);
        qe.setExtraStackFrame(s);
      } else
        qe.setExtraStackFrame(null);
    }
    var je;
    je = !1;
    function ke(e) {
      return typeof e == "object" && e !== null && e.$$typeof === r;
    }
    function Qe() {
      {
        if (Pe.current) {
          var e = W(Pe.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function Bt(e) {
      return "";
    }
    var Ze = {};
    function Ut(e) {
      {
        var n = Qe();
        if (!n) {
          var s = typeof e == "string" ? e : e.displayName || e.name;
          s && (n = `

Check the top-level render call using <` + s + ">.");
        }
        return n;
      }
    }
    function Xe(e, n) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var s = Ut(n);
        if (Ze[s])
          return;
        Ze[s] = !0;
        var l = "";
        e && e._owner && e._owner !== Pe.current && (l = " It was passed a child from " + W(e._owner.type) + "."), te(e), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', s, l), te(null);
      }
    }
    function et(e, n) {
      {
        if (typeof e != "object")
          return;
        if (Ie(e))
          for (var s = 0; s < e.length; s++) {
            var l = e[s];
            ke(l) && Xe(l, n);
          }
        else if (ke(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var E = N(e);
          if (typeof E == "function" && E !== e.entries)
            for (var b = E.call(e), m; !(m = b.next()).done; )
              ke(m.value) && Xe(m.value, n);
        }
      }
    }
    function Gt(e) {
      {
        var n = e.type;
        if (n == null || typeof n == "string")
          return;
        var s;
        if (typeof n == "function")
          s = n.propTypes;
        else if (typeof n == "object" && (n.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        n.$$typeof === v))
          s = n.propTypes;
        else
          return;
        if (s) {
          var l = W(n);
          At(s, e.props, "prop", l, e);
        } else if (n.PropTypes !== void 0 && !je) {
          je = !0;
          var E = W(n);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof n.getDefaultProps == "function" && !n.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vt(e) {
      {
        for (var n = Object.keys(e.props), s = 0; s < n.length; s++) {
          var l = n[s];
          if (l !== "children" && l !== "key") {
            te(e), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", l), te(null);
            break;
          }
        }
        e.ref !== null && (te(e), y("Invalid attribute `ref` supplied to `React.Fragment`."), te(null));
      }
    }
    var tt = {};
    function rt(e, n, s, l, E, b) {
      {
        var m = Ae(e);
        if (!m) {
          var h = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (h += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var P = Bt();
          P ? h += P : h += Qe();
          var _;
          e === null ? _ = "null" : Ie(e) ? _ = "array" : e !== void 0 && e.$$typeof === r ? (_ = "<" + (W(e.type) || "Unknown") + " />", h = " Did you accidentally export a JSX literal instead of a component?") : _ = typeof e, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", _, h);
        }
        var O = $t(e, n, s, E, b);
        if (O == null)
          return O;
        if (m) {
          var k = n.children;
          if (k !== void 0)
            if (l)
              if (Ie(k)) {
                for (var re = 0; re < k.length; re++)
                  et(k[re], e);
                Object.freeze && Object.freeze(k);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              et(k, e);
        }
        if (ue.call(n, "key")) {
          var z = W(e), j = Object.keys(n).filter(function(qt) {
            return qt !== "key";
          }), Me = j.length > 0 ? "{key: someKey, " + j.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!tt[z + Me]) {
            var zt = j.length > 0 ? "{" + j.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Me, z, zt, z), tt[z + Me] = !0;
          }
        }
        return e === i ? Vt(O) : Gt(O), O;
      }
    }
    function Yt(e, n, s) {
      return rt(e, n, s, !0);
    }
    function Ht(e, n, s) {
      return rt(e, n, s, !1);
    }
    var Kt = Ht, Jt = Yt;
    fe.Fragment = i, fe.jsx = Kt, fe.jsxs = Jt;
  })()), fe;
}
var ut;
function xr() {
  return ut || (ut = 1, process.env.NODE_ENV === "production" ? _e.exports = br() : _e.exports = Cr()), _e.exports;
}
var a = xr();
const mn = ({
  getValueByKey: t
}) => {
  const r = t("dixaApiTokenId")?.value, o = t("dixaApiTokenName")?.value;
  return /* @__PURE__ */ a.jsx(ge, { children: /* @__PURE__ */ a.jsx(Q, { label: "Dixa API-Token", children: !o || !r ? /* @__PURE__ */ a.jsx(a.Fragment, { children: "Something seems odd with the Api-Token. No name and/or id available." }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    "A Dixa Token with the name",
    " ",
    /* @__PURE__ */ a.jsx(Le, { variant: "secondary", size: "small", children: o }),
    " ",
    "was created.",
    " ",
    /* @__PURE__ */ a.jsx(lr, { to: `/settings/integrations/api-tokens/${r}`, children: "You can visit it on the Api-Token page" }),
    "."
  ] }) }) });
}, wr = ({
  error: t
}) => t.extensions?.integration?.code === "DIXA_HEADER_CHECK_ERROR", vn = ({
  errors: t
}) => t.some((r) => wr({ error: r })), Tr = ({
  error: t
}) => t.extensions?.integration?.code === "DOWNSTREAM_API_AUTHORIZATION_ERROR", yn = ({
  errors: t
}) => t.some((r) => Tr({ error: r })), _r = ({
  error: t
}) => t.extensions?.integration?.code === "DOWNSTREAM_API_PERMISSION_ERROR", En = ({
  errors: t
}) => t.some((r) => _r({ error: r })), Or = ({
  error: t
}) => t.extensions?.integration?.code === "DOWNSTREAM_API_SERVICE_UNAVAILABLE_ERROR", bn = ({
  errors: t
}) => t.some((r) => Or({ error: r })), Rr = ({
  error: t
}) => t.extensions?.integration?.code === "DOWNSTREAM_API_NOT_FOUND_ERROR", Cn = ({
  errors: t
}) => t.some((r) => Rr({ error: r })), Sr = ({
  error: t
}) => t.extensions?.integration?.code === "DOWNSTREAM_API_CONFLICT_ERROR", xn = ({
  errors: t
}) => t.some((r) => Sr({ error: r })), Ar = ({
  error: t
}) => t.extensions?.integration?.code === "DOWNSTREAM_API_BAD_REQUEST_ERROR", wn = ({
  errors: t
}) => t.some((r) => Ar({ error: r })), Dr = ({
  error: t
}) => t.extensions?.integration?.code === "DOWNSTREAM_API_FORBIDDEN_ERROR", Tn = ({
  errors: t
}) => t.some((r) => Dr({ error: r })), Nr = ({
  error: t
}) => t.extensions?.integration?.code === "DOWNSTREAM_API_TOO_MANY_REQUESTS_ERROR", _n = ({
  errors: t
}) => t.some((r) => Nr({ error: r })), Ir = ({
  error: t
}) => t.extensions?.integration?.code === "WIDGET_MISCONFIGURED_ERROR", Pr = ({
  errors: t
}) => t.some((r) => Ir({ error: r })), jr = (t) => {
  const { delay: r = 2e3 } = t || {}, [o, i] = R(!1);
  return F(() => {
    const d = o ? window.setTimeout(() => i(!1), r) : void 0;
    return () => window.clearTimeout(d);
  }, [r, o]), { isCopied: o, copy: (d) => {
    navigator.clipboard.writeText(d), i(!0);
  } };
}, kr = "_errorWrapper_171rr_1", Mr = "_copyIcon_171rr_5", We = {
  errorWrapper: kr,
  copyIcon: Mr
}, Fr = ({
  error: t,
  retry: r,
  isMisconfigured: o = !1
}) => {
  const c = t && Xt(t) && t?.graphQLErrors?.length > 0, { isCopied: d, copy: g } = jr(), C = /* @__PURE__ */ a.jsx(
    $e,
    {
      color: K.red[500],
      size: 16,
      name: "exclamation-triangle-filled"
    }
  );
  if (o || c && Pr({
    errors: t.graphQLErrors
  }))
    return /* @__PURE__ */ a.jsxs(M, { margin: "0 0 100", padding: "200", className: We.errorWrapper, children: [
      /* @__PURE__ */ a.jsx(M, { margin: "0 300 0 0", alignItems: "center", children: C }),
      /* @__PURE__ */ a.jsx(oe.Paragraph, { color: "secondary", children: "This integration is not properly configured and could not be loaded. Please contact your administrator." })
    ] });
  if (!c)
    return /* @__PURE__ */ a.jsx(M, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ a.jsx(
      nt.Item,
      {
        contentLeft: C,
        title: "Something went wrong. Please try again later.",
        variant: "dense"
      }
    ) });
  const p = t?.graphQLErrors || [];
  return /* @__PURE__ */ a.jsxs(
    M,
    {
      margin: "200 0 300",
      flexDirection: "column",
      className: We.errorWrapper,
      children: [
        p.map((x, u) => {
          const v = x?.extensions?.integration, w = v?.message || t?.message || "No error message available", T = v?.responseBody && JSON.parse(v?.responseBody), S = T?.errorMessages || [], D = T?.warningMessages || [], N = [...S, ...D].join(" ");
          return /* @__PURE__ */ a.jsx(
            nt.Item,
            {
              title: w,
              titleSecondary: N,
              contentLeft: C
            },
            u
          );
        }),
        /* @__PURE__ */ a.jsxs(M, { margin: "200 0 300", flexDirection: "column", gap: "200", children: [
          /* @__PURE__ */ a.jsx(
            tr,
            {
              variant: "info",
              description: /* @__PURE__ */ a.jsx(oe.Paragraph, { variant: "4", children: "Please copy the error details by clicking on the button below and include them in your support request." })
            }
          ),
          /* @__PURE__ */ a.jsxs(M, { flexDirection: "row", gap: "200", justifyContent: "space-between", children: [
            r && /* @__PURE__ */ a.jsx(ie, { variant: "secondary", icon: "sync", onClick: () => r(), children: "Retry" }),
            /* @__PURE__ */ a.jsx(
              ie,
              {
                variant: "secondary",
                icon: d ? "done" : "copy",
                onClick: () => g(JSON.stringify(p, null, 2)),
                className: We.copyIcon,
                children: "Copy error payload"
              }
            )
          ] })
        ] })
      ]
    }
  );
}, Wr = ({
  headline: t,
  text: r,
  children: o,
  onConfirm: i,
  onCancel: c,
  confirmLabel: d,
  cancelLabel: g = "Cancel",
  confirmVariant: C = "primary",
  cancelVariant: p = "secondary",
  isOpen: x,
  setIsOpen: u,
  showOnClose: v = !1
}) => /* @__PURE__ */ a.jsxs(
  rr,
  {
    isOpen: x,
    onClose: () => {
      c && c(), u(!1);
    },
    children: [
      /* @__PURE__ */ a.jsx(
        nr,
        {
          title: t,
          onClose: v ? c : void 0
        }
      ),
      /* @__PURE__ */ a.jsxs(or, { children: [
        r && /* @__PURE__ */ a.jsx("div", { style: { width: "600px" }, children: r }),
        o
      ] }),
      /* @__PURE__ */ a.jsx(
        ir,
        {
          confirmOnClick: i ? () => {
            i(), u(!1);
          } : void 0,
          cancelOnClick: () => {
            c && c(), u(!1);
          },
          confirmName: d,
          cancelName: g,
          confirmProps: { variant: C },
          cancelProps: { variant: p }
        }
      )
    ]
  }
);
function On(t, r = !0) {
  try {
    return JSON.parse(JSON.stringify(t));
  } catch {
    return r && console.error(`Could not make a copy of ${JSON.stringify(t)}`), {};
  }
}
const Rn = (t) => `${t.charAt(0).toUpperCase()}${t.slice(1).toLowerCase()}`, wt = "DD MMM YYYY @ HH:mm";
function Lr(t, r) {
  return t == null ? r : typeof t == "boolean" ? t : t === "true";
}
function $r(t, r) {
  return t == null ? r : String(t);
}
function Sn(t) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      t.toUpperCase()
    ) ?? t;
  } catch {
    return t;
  }
}
const An = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], Dn = (t) => {
  if (!t?.trim())
    return "Please add a valid subdomain";
  const o = ["https://", "http://"].find(
    (d) => t.startsWith(d)
  ), i = o ? `Please remove the protocol \`${o}\` from the hostname` : "", c = t.endsWith("/") ? "Please remove the trailing `/` from the hostname" : "";
  if (i && c)
    return `Please remove the protocol \`${o}\` and the trailing \`/\` from the hostname`;
  if (i)
    return i;
  if (c)
    return c;
};
function Br(t) {
  const r = t.split(".")[1];
  if (!r)
    throw Error("Invalid token");
  const o = r.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(atob(o).toString());
  } catch (i) {
    throw Error(
      `Failed to parse the JSON Web Token with the following error: ${i}`
    );
  }
}
function Nn(t, r) {
  const o = {};
  for (const i of r) {
    const d = t.find((g) => g.key === i.key)?.value;
    i.secret && d === void 0 || (i.type === "boolean" ? o[i.key] = Lr(d, i.defaultValue) : o[i.key] = $r(d, i.defaultValue));
  }
  return o;
}
function In(t, r) {
  return r.filter((o) => t[o.key] !== void 0).map((o) => ({
    key: o.key,
    value: String(t[o.key]),
    secret: o.secret
  }));
}
function Ur(t) {
  const { user_id: r, iss: o } = Br(t);
  return {
    "x-integration-user-id": r,
    "x-integration-organization-id": o
  };
}
function Gr(t) {
  return t.startsWith("http://localhost");
}
const Vr = gt(null);
function Yr() {
  const t = pt(Vr);
  if (t === null)
    throw Error(
      "useInboundOAuthContext requires InboundOAuthContext to be used higher up in the component tree, below InboundOAuthContext.Provider"
    );
  return t;
}
function Pn() {
  return {
    isInboundOAuth: !1,
    setIsInboundOAuth: () => {
    },
    hasTriggeredAuthorization: !1,
    setHasTriggeredAuthorization: () => {
    }
  };
}
function Be() {
  return { track: (r, o) => window._partner.events.emit(r, o) };
}
const Hr = (t) => {
  switch (t) {
    case "CONNECTED":
      return {
        icon: "check-circle-filled",
        color: K.green[500],
        tooltip: "Connected"
      };
    case "CONNECTING":
      return {
        icon: "sync",
        color: K.neutral[500],
        tooltip: "Connecting.."
      };
    case "CONNECTION_FAILED":
      return {
        icon: "close-circle-filled",
        color: K.red[500],
        tooltip: "Connection failed"
      };
    case "CONNECTION_TIMEOUT":
      return {
        icon: "exclamation-triangle-filled",
        color: K.red[200],
        tooltip: "Connection timeout"
      };
    case "NOT_CONNECTED":
    default:
      return {
        icon: "exclamation-circle-filled",
        color: K.neutral[500],
        tooltip: "Not connected"
      };
  }
}, jn = ({
  configuration: t,
  integrationId: r,
  integrationType: o,
  label: i
}) => {
  const [c, d] = R("CONNECTING"), [g, C] = R(""), [p, x] = R(null), { track: u } = Be(), { icon: v, color: w, tooltip: T } = Hr(c), S = 3, D = 15, N = 2e3, [f, y] = R({}), [I, V] = R(0), [J, B] = R(N), [Se, ae] = R(!1), [pe, Ae] = R(S), {
    isInboundOAuth: De,
    setIsInboundOAuth: he,
    hasTriggeredAuthorization: W,
    setHasTriggeredAuthorization: U
  } = Yr(), { baseUrl: L } = t, me = `${L}/auth/connect/${o.toLowerCase()}/${r}`, ve = `${L}/auth/status/${o.toLowerCase()}/${r}`, se = c === "CONNECTING", ce = (A) => Object.keys(A).length === 0, X = () => {
    ae(!1), V(0);
  };
  F(() => {
    const A = localStorage.getItem("authData");
    if (A) {
      const $ = JSON.parse(A ?? "{}").access_token;
      y({
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${$}`,
          ...Gr(L) && Ur($)
        }
      });
    }
  }, [L]), F(() => {
    ce(f) || ae(!0);
  }, [f]);
  const ye = () => {
    Ae(D), fetch(ve, { ...f }).then((A) => A.json()).then(({ data: A }) => {
      const { status: Y, createdAt: $, createdByName: G } = A;
      if (Y === "CONNECTING" && d("CONNECTING"), Y === "CONNECTED") {
        if (u("settings:view:oauth:succeeded", {
          widgetId: r,
          widgetType: o
        }), d("CONNECTED"), $ && G) {
          const H = new Date($);
          isNaN(H.getTime()) || x(H), C(G);
        }
        X();
      }
      Y === "NOT_CONNECTED" && (d("NOT_CONNECTED"), X());
    }).catch((A) => {
      console.warn(
        `Fetching OAuth status failed for ${o} ${r}`,
        A
      ), d("CONNECTION_FAILED");
    });
  };
  ur(
    () => {
      I >= pe ? (d("CONNECTION_TIMEOUT"), X()) : (ye(), V(I + 1));
    },
    Se ? J : null
  );
  const le = () => {
    u("settings:view:oauth:started", {
      widgetId: r,
      widgetType: o
    }), fetch(me, { ...f }).then((A) => A.json()).then(({ data: A }) => {
      const { url: Y } = A, $ = 620, G = 800, H = window.innerWidth / 2 - $ / 2, ee = window.innerHeight / 2 - G / 2;
      d("CONNECTING"), ae(!0), window.open(
        Y,
        "DixaPartnerOAuth",
        `toolbar=no,
						location=no,
						status=no,
						menubar=no,
						scrollbars=yes,
						resizable=yes,
						width=${$},
						height=${G},
						left=${H},
						top=${ee}`
      );
    }).catch((A) => {
      console.warn(
        `Fetching OAuth connection failed for ${o} ${r}`,
        A
      ), d("CONNECTION_FAILED");
    });
  };
  return F(() => {
    De && !W && !ce(f) && (U(!0), he(!1), le());
  }, [f]), /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(ge, { span: 3, children: /* @__PURE__ */ a.jsx(
      Q,
      {
        label: i,
        meta: {
          warning: "All agents interact with the widget using your access permissions."
        },
        style: { marginBottom: 20 },
        children: /* @__PURE__ */ a.jsxs(M, { flexDirection: "row", alignItems: "baseline", gap: "300", children: [
          /* @__PURE__ */ a.jsx(
            ie,
            {
              icon: "key",
              variant: "secondary",
              onClick: le,
              disabled: se,
              style: { marginBottom: 8 },
              children: "Start authorization"
            }
          ),
          /* @__PURE__ */ a.jsx(ht, { content: T, children: se ? /* @__PURE__ */ a.jsx(mt, { "data-testid": "oauth-button-spinner", size: 18 }) : /* @__PURE__ */ a.jsxs(M, { alignItems: "center", gap: "200", children: [
            /* @__PURE__ */ a.jsx(
              $e,
              {
                "data-testid": "oauth-button-status-icon",
                name: v,
                color: w
              }
            ),
            c === "CONNECTED" && g && p && /* @__PURE__ */ a.jsxs(oe.Paragraph, { variant: "4", subdued: !0, children: [
              "Authorized by ",
              g,
              " at",
              " ",
              vt(p).format(wt)
            ] })
          ] }) })
        ] })
      }
    ) }),
    /* @__PURE__ */ a.jsx(ge, { span: 3 })
  ] });
}, Tt = gt(null), kn = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Tt.Provider
);
function _t() {
  const t = pt(Tt);
  if (t === null)
    throw Error(
      "useWidgetContext requires WidgetContext to be used higher up in the component tree, below WidgetContextProvider"
    );
  return t;
}
const Kr = "_settingsWrapper_eleyu_1", Jr = {
  settingsWrapper: Kr
}, zr = Z`
  query getLists {
    Klaviyo {
      get_lists {
        ... on Klaviyo_get_lists_response {
          ... on Klaviyo_GetListListResponseCollectionCompoundDocument {
            data {
              type
              id
              attributes {
                name
                created
                updated
              }
              links {
                self
              }
            }
            links {
              self
            }
          }
          ... on Klaviyo_ClientError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
          ... on Klaviyo_ServerError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
        }
      }
    }
  }
`, dt = [], Mn = ({
  settings: t,
  getValueByKey: r,
  handleChangeSelect: o
}) => {
  const i = "subscriptionListId", d = t?.find(
    (f) => f.key === i
  )?.label ?? "Activate re-/subscription list selection", g = r(i)?.value, { useQuery: C } = _t(), [p, x] = R(dt), [u, v] = R(!!g), [w, T] = R(g), {
    data: S,
    error: D,
    loading: N
  } = C(zr, {
    skip: !u,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return F(() => {
    g && (T(g), v(!0));
  }, [g]), F(() => {
    const f = S?.Klaviyo?.get_lists;
    if (u && f && !N && !D) {
      const y = f?.data?.map(
        (I) => ({
          value: I?.id,
          label: I?.attributes?.name
        })
      ) || dt;
      x(y);
    }
  }, [u, S, N, D]), /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(ge, { span: 3, children: /* @__PURE__ */ a.jsxs(
      M,
      {
        gap: "300",
        flexDirection: "column",
        className: Jr.settingsWrapper,
        children: [
          /* @__PURE__ */ a.jsx(Q, { label: d, children: /* @__PURE__ */ a.jsx(
            ar,
            {
              input: {
                name: `${i}-switch`,
                value: "switchValueFromComponent",
                checked: u,
                onChange: () => {
                  const f = !u;
                  f || o(i, {
                    selectedValues: [
                      {
                        label: "",
                        value: ""
                      }
                    ]
                  }), v(f);
                }
              }
            }
          ) }),
          u && D && !N && /* @__PURE__ */ a.jsx(Q, { children: /* @__PURE__ */ a.jsx(Fr, { error: D }) }),
          u && !D && N && /* @__PURE__ */ a.jsx(Q, { children: /* @__PURE__ */ a.jsx(M, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ a.jsx(mt, {}) }) }),
          u && !D && !N && p && /* @__PURE__ */ a.jsx(Q, { label: "Available lists to subscribe to", children: /* @__PURE__ */ a.jsx(
            sr,
            {
              required: !0,
              placeholder: "Select a list",
              onChange: (f) => {
                o(i, f), T(f?.selectedValues?.[0].value);
              },
              getItemTitleByValue: (f) => f ? /* @__PURE__ */ a.jsx(oe.Paragraph, { children: f.label }) : null,
              value: w ? [
                {
                  label: (p || []).find(
                    (f) => f.value === w
                  )?.label,
                  value: w
                }
              ] : [],
              equalityFn: (f, y) => f.value === y.value,
              children: p.map((f) => /* @__PURE__ */ a.jsx(cr.Item, { value: f, children: f.label }, f.value))
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ a.jsx(ge, { span: 3 })
  ] });
}, Fn = (t) => {
  if (t == null)
    return null;
  if (typeof t == "boolean" || t === "true" || t === "false") {
    const i = t === "true" || t === !0;
    return /* @__PURE__ */ a.jsx(
      $e,
      {
        name: i ? "check-circle-filled" : "close-circle-filled",
        color: i ? K.green[500] : K.red[500],
        size: 14,
        "data-testid": `displayAttributeValue-icon-${i ? "true" : "false"}`
      }
    );
  }
  if (typeof t == "number" || /^\d*\.?\d+$/.test(t))
    return /* @__PURE__ */ a.jsx(Le, { variant: "success", size: "small", children: t });
  if (t.startsWith("days_ago: ")) {
    const i = t.replace("days_ago: ", ""), c = i.startsWith("-"), d = i === "0", g = c ? `${i.replace("-", "")} days ago` : `in ${i} days`;
    return /* @__PURE__ */ a.jsx(oe.Paragraph, { variant: "5", color: "secondary", children: d ? "today" : g });
  }
  const o = vt(t);
  return o.isValid() ? /* @__PURE__ */ a.jsx(oe.Paragraph, { variant: "5", color: "secondary", children: o.format(wt) }) : /* @__PURE__ */ a.jsx(Le, { variant: "info", size: "small", children: t });
}, Wn = (t) => {
  const { isCreationMode: r = !1, label: o, helpIcon: i, name: c } = t, [d, g] = R(r);
  if (!d) {
    const C = typeof o == "string" ? o : "";
    return /* @__PURE__ */ a.jsx(Q, { label: o, helpIcon: i, children: /* @__PURE__ */ a.jsxs(
      ie,
      {
        "data-testid": `secret-field-button-${c}`,
        variant: "secondary",
        icon: "pen",
        onClick: () => g(!0),
        children: [
          "Update ",
          C
        ]
      }
    ) });
  }
  return /* @__PURE__ */ a.jsx(
    qr,
    {
      ...t,
      isCreationMode: r,
      onClose: () => g(!1)
    }
  );
}, qr = (t) => {
  const { isCreationMode: r, componentProps: o, onClose: i } = t, c = {
    ...o,
    prefix: r ? o?.prefix : {
      type: "button",
      button: { icon: "close", onClick: i }
    }
  };
  return /* @__PURE__ */ a.jsx(
    dr,
    {
      ...t,
      componentProps: c,
      shouldUnregister: !0
    }
  );
}, Qr = {
  submit: "Submit",
  delete: "Delete",
  confirmDelete: "Yes",
  cancelDelete: "No"
}, Ln = ({
  integrationType: t,
  integrationId: r,
  widgetName: o,
  isCreationMode: i,
  isSubmitting: c,
  automationCouplingState: d,
  onConfirmDelete: g,
  labels: C,
  deleteConfirmationBody: p,
  confirmDeleteVariant: x = "primary"
}) => {
  const { track: u } = Be(), [v, w] = R(!1), T = { ...Qr, ...C }, S = !d || !d.isCoupled, D = () => {
    r && u("settings:view:delete:requested", {
      widgetId: r,
      widgetType: t
    }), w(!0);
  }, N = () => {
    r && u("settings:view:delete:canceled", {
      widgetId: r,
      widgetType: t
    });
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs(M, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ a.jsx(ie, { type: "submit", isLoading: c, disabled: c, children: T.submit }),
      !i && /* @__PURE__ */ a.jsx(
        ht,
        {
          content: "The widget is used in automations",
          disabled: S,
          children: /* @__PURE__ */ a.jsx(
            ie,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              type: "button",
              onClick: D,
              disabled: !S,
              isLoading: d?.isLoading,
              children: T.delete
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ a.jsx(
      Wr,
      {
        isOpen: v,
        setIsOpen: w,
        confirmVariant: x,
        confirmLabel: T.confirmDelete,
        cancelLabel: T.cancelDelete,
        onCancel: N,
        onConfirm: g,
        children: /* @__PURE__ */ a.jsx(M, { children: p ?? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
          "Are you sure you want to delete the ",
          t,
          ' integration "',
          o,
          '"?'
        ] }) })
      }
    )
  ] });
}, Zr = Z`
  query read($conversationId: String!) {
    Storage {
      widgetData(conversation: $conversationId)
    }
  }
`, Xr = Z`
  mutation store($conversationId: String!, $data: Storage_JSONObject) {
    Storage {
      storeWidgetData(conversation: $conversationId, data: $data) {
        data
      }
    }
  }
`;
function $n(t) {
  const { useQuery: r, useMutation: o } = _t(), [i, c] = R(), [d, g] = R(), [C, p] = R(!1), {
    loading: x,
    data: u,
    error: v
  } = r(
    Zr,
    {
      skip: !t,
      variables: {
        conversationId: t?.toString()
      }
    }
  ), [w, { loading: T, error: S }] = o(
    Xr
  ), D = async (N, f) => await w({
    variables: {
      conversationId: (f ?? t)?.toString(),
      data: N
    }
  }).then(
    ({ data: I }) => c(I?.Storage?.storeWidgetData?.data ?? {})
  );
  return F(() => {
    !x && u && c(u?.Storage?.widgetData ?? {});
  }, [u, x]), F(() => v && g(v), [v]), F(() => p(x), [x]), F(() => S && g(S), [S]), F(() => p(T), [T]), {
    data: i,
    loading: C,
    store: D,
    error: d
  };
}
const en = "The configuration of the integration is not correct. Please check the settings.", Bn = ({
  integrationId: t,
  integrationType: r,
  handleRedirect: o,
  showNotification: i
}) => {
  const { track: c } = Be(), [d, g] = R(!1), [C, p] = R(), [x, u] = R(null), v = xe(
    (y) => (I) => {
      p(I), g(!1), i({
        title: "Something went wrong",
        text: `The ${y} of the widget was not successful.`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    [i]
  ), [w] = Oe(gr, {
    onError: v("creation")
  }), [T] = Oe(fr, {
    onError: v("update")
  }), [S] = Oe(pr, {
    onError: v("deletion")
  }), D = xe(
    async ({ name: y, enabled: I, settings: V }) => {
      c("settings:create:submitted", { widgetType: r }), g(!0), p(void 0);
      const { data: J } = await w({
        variables: { type: r, name: y, enabled: I, settings: V }
      });
      g(!1);
      const B = J?.Management?.createWidgetConfiguration;
      if (!B) {
        i({
          title: "Something went wrong",
          text: "The creation of the widget was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
        return;
      }
      i({
        title: "Creating was successful",
        text: "Creating the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o(B.id);
    },
    [w, o, r, i, c]
  ), N = xe(
    async ({ name: y, enabled: I, settings: V }) => {
      if (!t)
        return;
      c("settings:view:change:submitted", {
        widgetId: t,
        widgetType: r
      }), g(!0), p(void 0);
      const { data: J } = await T({
        variables: { id: t, name: y, enabled: I, settings: V }
      });
      g(!1);
      const B = J?.Management?.updateWidgetConfiguration;
      if (!B) {
        i({
          title: "Something went wrong",
          text: "The update of the widget was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
        return;
      }
      B.misconfigured ? u(
        B.misconfigurationCause ?? en
      ) : u(null), i({
        title: "Updating was successful",
        text: "Updating the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    },
    [t, r, i, c, T]
  ), f = xe(async () => {
    if (!t)
      return;
    c("settings:view:delete:confirmed", {
      widgetId: t,
      widgetType: r
    }), g(!0), p(void 0);
    const { data: y } = await S({
      variables: { id: t }
    });
    g(!1), y?.Management?.deleteWidgetConfiguration && (o(), i({
      title: "Deletion was successful",
      text: "The deletion of the widget was successful.",
      icon: "check-circle-filled",
      severity: "success"
    }));
  }, [
    S,
    o,
    t,
    r,
    i,
    c
  ]);
  return {
    create: D,
    update: N,
    remove: f,
    isLoading: d,
    error: C,
    misconfigurationCause: x,
    setMisconfigurationCause: u
  };
};
export {
  Fr as DisplayErrors,
  mn as DixaApiTokenSettings,
  Vr as InboundOAuthContext,
  Wr as IntegrationModal,
  Mn as KlaviyoSubscribeSetting,
  jn as OAuthSettings,
  Wn as PartnerHookFormSecretText,
  kn as WidgetContextProvider,
  Ln as WidgetSettingsFormFooter,
  Rn as capitalizeFirstCharacter,
  An as countryCodes,
  Pn as createMockInboundOAuthContextOptions,
  gr as createWidgetConfigurationMutation,
  On as deepClone,
  wt as defaultDateFormat,
  pr as deleteWidgetConfigurationMutation,
  Fn as displayAttributeValue,
  In as formValuesToSettings,
  Hr as getConnectionStatusValues,
  Sn as getCountryNameFromCountryCode,
  zr as getListsQuery,
  Ur as getPartnerDevApiHeaders,
  dn as getWidgetConfigurationByIdQuery,
  vn as hasDixaHeaderCheckError,
  yn as hasDownstreamApiAuthorizationError,
  wn as hasDownstreamApiBadRequestError,
  xn as hasDownstreamApiConflictError,
  Tn as hasDownstreamApiForbiddenError,
  Cn as hasDownstreamApiNotFoundError,
  En as hasDownstreamApiPermissionError,
  bn as hasDownstreamApiServiceUnavailableError,
  _n as hasDownstreamApiTooManyRequestsError,
  Pr as hasWidgetMisconfiguredError,
  wr as isDixaHeaderCheckError,
  Tr as isDownstreamApiAuthorizationError,
  Ar as isDownstreamApiBadRequestError,
  Sr as isDownstreamApiConflictError,
  Dr as isDownstreamApiForbiddenError,
  Rr as isDownstreamApiNotFoundError,
  _r as isDownstreamApiPermissionError,
  Or as isDownstreamApiServiceUnavailableError,
  Nr as isDownstreamApiTooManyRequestsError,
  Gr as isRunningLocalPartnerApi,
  Ir as isWidgetMisconfiguredError,
  pn as makeExecuteQuery,
  gn as makeUseLazyQuery,
  hn as makeUseMutation,
  fn as makeUseQuery,
  Br as parseAccessToken,
  Lr as parseBoolean,
  $r as parseString,
  Nn as settingsToFormValues,
  fr as updateWidgetConfigurationMutation,
  jr as useCopyWithDelay,
  $n as useData,
  Yr as useInboundOAuthContext,
  Be as useTracking,
  _t as useWidgetContext,
  Bn as useWidgetSettingsMutations,
  Dn as validateApiHostName
};
